var React = require('react');

function BedBunk (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M144,256a48,48,0,1,0,48,48A48.06,48.06,0,0,0,144,256ZM144,0a48,48,0,1,0,48,48A48.06,48.06,0,0,0,144,0ZM464,0H240a16,16,0,0,0-16,16V128H576V112A112,112,0,0,0,464,0ZM240,256a16,16,0,0,0-16,16V384H512V267.19A110.87,110.87,0,0,0,464,256Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M64,128V16A16,16,0,0,0,48,0H16A16,16,0,0,0,0,16V496a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V448H512v48a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V128ZM512,384H64V192H512Z","className":"fa-primary","key":2})]);
}

BedBunk.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = BedBunk;

BedBunk.default = BedBunk;
